import Page from '../../classes/Page';
import carouselsData from '../../carouselData/home';
import createCapabilitiesAnimation from './capabilitiesAnimation';
import createProjectsAnimation from './projectsAnimation';

const homePage = new Page({
	onInit() {
		createCapabilitiesAnimation();
		createProjectsAnimation();
	},
	name: 'home',
	rootElementId: 'js-home-page',
	carousels: carouselsData
});

export default homePage;
